import React, { useState, useEffect } from 'react'
import Layout from '../../layouts/Layout'
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { FaSearch, FaEdit, FaTrash } from "react-icons/fa";
import Swal from 'sweetalert2';
import { Tabs, Tab } from 'react-bootstrap';
import { createShippingZoneAPI, deleteShippingMethodAPI, getShippingMethodListAPI, getRegionListAPI, getShippingZoneListAPI, deleteShippingZoneAPI, getShippingRateListAPI, deleteShippingRateAPI } from '../../services/api/ShippingAPI';
import { Modal } from 'react-bootstrap';
import { FaStarOfLife } from 'react-icons/fa';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Loader from '../components/Loader';
import Select from "react-select";

const Shippings = () => {
    const navigate = useNavigate();
    const [products, setProducts] = useState([]);
    const [zoneList, setZoneList] = useState([]);
    const [rateList, setRateList] = useState([]);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const user = useSelector((state) => state.LoginReducer.authData);
    const token = user.data.token;
    const [loading, setLoading] = useState(false);
    const [editShow, setEditShow] = useState(false);
    const [options, setOptions] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);

    const editHandleShow = () => setEditShow(true);
    const handleClose = () => setEditShow(false);

    const onGlobalFilterChange = (e) => {
        setGlobalFilterValue(e.target.value);
    };

    useEffect(() => {
        fetchShippingList();
        fetchShippingZoneList();
        fetchShippingRateList();
    }, []);

    const fetchShippingList = async () => {
        try {
            const data = await getShippingMethodListAPI(token);
            if(data.status){
                setProducts(data.data);
            }
        } catch (error) {
            console.error('Error fetching user list:', error);
        } finally {
        }
    };

    const fetchShippingRateList = async () => {
        try {
            const data = await getShippingRateListAPI(token);
            if(data.status){
                setRateList(data.data);
            }
        } catch (error) {
            console.error('Error fetching user list:', error);
        } finally {
        }
    };

    const fetchShippingZoneList = async () => {
        try {
            const data = await getShippingZoneListAPI(token);
            if(data.status){
                setZoneList(data.data);
            }
        } catch (error) {
            console.error('Error fetching user list:', error);
        } finally {
        }
    };

    const handleEdit = (id) => {
        navigate(`/shippings/edit-shipping-method/${id}`);
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
        });
    
        if (result.isConfirmed) {
            try {
                const data = await deleteShippingMethodAPI(id, token);
                if(data.status){
                    fetchShippingList();
                    Swal.fire(
                        'Deleted!',
                        'Shipping method has been deleted.',
                        'success'
                    );
                }
            } catch (error) {
                Swal.fire(
                    'Error!',
                    'Something went wrong please try again.',
                    'error'
                );
            }
        }
    };

    const handleZoneEdit = (id) => {
        navigate(`/shippings/edit-shipping-zone/${id}`);
    };

    const handleZoneDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
        });
    
        if (result.isConfirmed) {
            try {
                const data = await deleteShippingZoneAPI(id, token);
                if(data.status){
                    fetchShippingZoneList();
                    Swal.fire(
                        'Deleted!',
                        'Shipping method has been deleted.',
                        'success'
                    );
                }
            } catch (error) {
                Swal.fire(
                    'Error!',
                    'Something went wrong please try again.',
                    'error'
                );
            }
        }
    };

    const handleRateEdit = (id) => {
        navigate(`/shippings/edit-shipping-rate/${id}`);
    };

    const handleRateDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
        });
    
        if (result.isConfirmed) {
            try {
                const data = await deleteShippingRateAPI(id, token);
                if(data.status){
                    fetchShippingRateList();
                    Swal.fire(
                        'Deleted!',
                        'Shipping rate has been deleted.',
                        'success'
                    );
                }
            } catch (error) {
                Swal.fire(
                    'Error!',
                    'Something went wrong please try again.',
                    'error'
                );
            }
        }
    };

    const validationSchema = Yup.object({
        name: Yup.string()
            .min(3, 'Name must be at least 3 characters long')
            .required('Name is required'),
        region_ids: Yup.array()
            .required('Region is required')
            .min(1, 'At least one region is required')
            .of(Yup.number().required('Each region must be a valid id')),
    });

    const formik = useFormik({
        initialValues: {
            name: '',
            region_ids: [],
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setLoading(true);
            const formData = new FormData();
            formData.append('name', values.name);
            values.region_ids.forEach(item => {
                formData.append('region_ids[]', item);
            });
            await createShippingZone(formData);
        },
    });

    const createShippingZone = async (formData) => {
        try {
            const data = await createShippingZoneAPI(formData, token);
            setLoading(false);
            if (data.status) {
                Swal.fire({
                    title: 'Shipping method Created!',
                    text: 'The shipping method has been created successfully.',
                    icon: 'success',
                    confirmButtonText: 'OK',
                }).then(() => {
                    fetchShippingZoneList();
                    handleClose();
                });
            }
        } catch (error) {
            setLoading(false);
            Swal.fire({
                title: 'Error!',
                text: 'Something went wrong please try again.',
                icon: 'error',
                confirmButtonText: 'OK',
            });
        }
    };

    useEffect(() => {
        const fetchRegion = async () => {
            try {
                const data = await getRegionListAPI(token);
                if (data.status) {
                    const options = data.data.map(item => ({
                        value: item.id,
                        label: item.name,
                    }));
                    setOptions(options);
                }
            } catch (error) {
                console.error('Error fetching regions list:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchRegion();
    }, [token]);

    const customStyles = {
        control: (provided) => ({
            ...provided,
            borderRadius: 'none',
            borderColor: 'none',
            boxShadow: 'none',
            borderStyle: 'none',
            '&:hover': {
                borderColor: '#007bff',
            },
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#007bff' : null,
            color: state.isSelected ? 'white' : 'black',
        }),
    };

    const handleChange = (selected) => {
        setSelectedOptions(selected);
        formik.setFieldValue('region_ids', selectedOptions.map(option => option.value));
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <Layout title="Shippings">
            <div className="container table-container">
                <Tabs defaultActiveKey="shippingZone" id="shipping-tabs">
                    <Tab eventKey="shippingZone" title="Shipping Zone">
                        <div className="mt-3">
                        <div className='d-flex justify-content-between'> 
                            <div className="mb-2  custom-input-group">
                                    <FaSearch className="search-icon" />
                                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" className="flex-grow-1" />
                                </div>
                                <div className="">
                                    <Link to={'/shippings/create-shipping-zone'} className='btn btn-primary'>Add Shipping Zone</Link>
                                </div>
                            </div>
                            <DataTable value={zoneList} paginator rows={10} sortField="name" sortOrder={1} removableSort stripedRows globalFilter={globalFilterValue} rowsPerPageOptions={[10, 25, 50, 100]} >
                                <Column field="id" header="ID" sortable></Column>
                                <Column field="name" header="Name" sortable></Column>
                                <Column 
                                    header="Actions" 
                                    body={(rowData) => (
                                        <div className='d-flex gap-2 align-items-center'>
                                            <button onClick={() => handleZoneEdit(rowData.id)} className="btn btn-warning edit"><FaEdit className='' /></button>
                                            <button onClick={() => handleZoneDelete(rowData.id)} className="btn btn-danger delete"><FaTrash className='' /></button>
                                        </div>
                                    )}>
                                </Column>
                            </DataTable>
                        </div>
                    </Tab>
                    <Tab eventKey="shippingMethod" title="Shipping Method">
                        <div className="mt-3">
                            <div className='d-flex justify-content-between'> 
                                    <div className="mb-2  custom-input-group">
                                    <FaSearch className="search-icon" />
                                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" className="flex-grow-1" />
                                </div>
                                <div className="">
                                    <Link to={'/shippings/create-shipping-method'} className='btn btn-primary'>Add Shipping Method</Link>
                                </div>
                            </div>
                            <DataTable value={products} paginator rows={10} sortField="name" sortOrder={1} removableSort stripedRows globalFilter={globalFilterValue} rowsPerPageOptions={[10, 25, 50, 100]} >
                                <Column field="id" header="ID" sortable></Column>
                                <Column field="name" header="Name" sortable></Column>
                                <Column field="tax_status" header="Tax Status" sortable></Column>
                                <Column
                                    field="free_shipping_requires"
                                    header="Free Shipping Requires"
                                    sortable
                                    body={(rowData) => {
                                            switch (rowData.free_shipping_requires) {
                                                case 'order_amount':
                                                    return 'Minimum order value';
                                                case 'item_quantity':
                                                    return 'Minimum item quantity (PRO)';
                                                case 'coupon':
                                                    return 'Free shipping coupon (PRO)';
                                                case 'order_amount_or_coupon':
                                                    return 'Free shipping coupon or minimum order amount (PRO)';
                                                case 'order_amount_and_coupon':
                                                    return 'Free shipping coupon and minimum order amount (PRO)';
                                                default:
                                                    return 'Minimum order value';
                                            }
                                        }
                                    }
                                /> 
                                <Column 
                                    header="Actions" 
                                    body={(rowData) => (
                                        <div className='d-flex gap-2 align-items-center'>
                                            <button onClick={() => handleEdit(rowData.id)} className="btn btn-warning edit"><FaEdit className='' /></button>
                                            <button onClick={() => handleDelete(rowData.id)} className="btn btn-danger delete"><FaTrash className='' /></button>
                                        </div>
                                    )}>
                                </Column>
                            </DataTable>
                        </div>
                    </Tab>
                    <Tab eventKey="shippingRate" title="Shipping Rate">
                        <div className="mt-3">
                            <div className='d-flex justify-content-between'> 
                                    <div className="mb-2  custom-input-group">
                                    <FaSearch className="search-icon" />
                                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" className="flex-grow-1" />
                                </div>
                                <div className="">
                                    <Link to={'/shippings/create-shipping-rate'} className='btn btn-primary'>Add Shipping Rate</Link>
                                </div>
                            </div>
                            <DataTable value={rateList} paginator rows={10} sortField="name" sortOrder={1} removableSort stripedRows globalFilter={globalFilterValue} rowsPerPageOptions={[10, 25, 50, 100]} >
                                <Column field="id" header="ID" sortable></Column>
                                <Column field="zone_name" header="Shipping Zone" sortable></Column>
                                <Column field="method_name" header="Shipping Method" sortable></Column>
                                <Column field="rate_type" header="Shipping Rate Type" sortable />
                                <Column field="rate_rang" header="Shipping Rate Range" sortable />
                                <Column field="rate" header="Shipping Rate" sortable />
                                <Column 
                                    header="Actions" 
                                    body={(rowData) => (
                                        <div className='d-flex gap-2 align-items-center'>
                                            <button onClick={() => handleRateEdit(rowData.id)} className="btn btn-warning edit"><FaEdit className='' /></button>
                                            <button onClick={() => handleRateDelete(rowData.id)} className="btn btn-danger delete"><FaTrash className='' /></button>
                                        </div>
                                    )}>
                                </Column>
                            </DataTable>
                        </div>
                    </Tab>
                </Tabs>
                {/*Edit Modal */}
                <Modal show={editShow}  size="md" backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Shipping Zone</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={formik.handleSubmit}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-12 col-12">
                                        <div className="form-group py-1 required">
                                            <label htmlFor="name">Name <FaStarOfLife className='text-danger' /></label>
                                            <input type="text" className="form-control mt-1" name="name" id="name" placeholder="Enter name" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.name || ''} />
                                        </div>
                                        {formik.touched.name && formik.errors.name ? (<label className="text-danger">{formik.errors.name}</label>) : null}
                                    </div>
                                    <div className="col-md-12 col-12">
                                        <div className="form-group py-3 required">
                                            <label htmlFor="region_ids">Product Category <FaStarOfLife className='text-danger' /></label>
                                            <Select isMulti name='region_ids' id='region_ids'
                                                value={options.filter(option => formik.values.region_ids.includes(option.value))}
                                                onChange={handleChange}
                                                options={options}
                                                className="form-control mt-1 p-0"
                                                classNamePrefix="select"
                                                styles={customStyles}
                                            />
                                        </div>
                                        {formik.touched.region_ids && formik.errors.region_ids ? (<label className="text-danger">{formik.errors.region_ids}</label>) : null}
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-12 col-12 d-flex gap-3 justify-content-center align-items-center">
                                            <button type="submit" className="btn btn-primary">Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            </div>
        </Layout>        
    )
}

export default Shippings